import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Checklist() {
  const [Check, setCheck] = useState([]);
  const [selectedService, setSelectedService] = useState("");
  const [selectedStatu, setSelectedStatu] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  
  // États pour la pagination
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalChecks, setTotalChecks] = useState(0);
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();
  const API_BASE = "https://srv968119.hstgr.cloud";
  const limitOptions = [10, 50, 100, 500, 1000];

  const fetchCheck = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      params.append("page", page);
      params.append("limit", limit);
      if (selectedService) params.append("service", selectedService);
      if (selectedStatu) params.append("statu", selectedStatu);
      if (searchTerm) params.append("search", searchTerm);

      const response = await fetch(`${API_BASE}/check?${params.toString()}`);
      const data = await response.json();
      
      // Vérifier si la réponse contient des données paginées
      if (data.checks && Array.isArray(data.checks)) {
        setCheck(data.checks);
        setTotalPages(data.totalPages || 1);
        setTotalChecks(data.totalChecks || data.checks.length);
      } else if (Array.isArray(data)) {
        // Cas ancienne API
        setCheck(data);
        setTotalPages(1);
        setTotalChecks(data.length);
      } else {
        // Cas erreur ou réponse inattendue
        setCheck([]);
        setTotalPages(1);
        setTotalChecks(0);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des checks :", error);
    } finally {
      setLoading(false);
    }
  };

  const retirer_avis = async (id) => {
    try {
      const response = await fetch(`${API_BASE}/check/retirer_avis/${id}`);
      const data = await response.json();
      if (data) {
        fetchCheck();
      }
      setShowModal(false); // Ferme la modale après suppression
    } catch (error) {
      console.error("Erreur lors du retrait de l'avis :", error);
    }
  };

  const confirmRetirerAvis = (id) => {
    setSelectedId(id);
    setShowModal(true);
  };

  // Génère les numéros de pagination
  const getPaginationNumbers = () => {
    let start = Math.max(1, page - 2);
    let end = Math.min(totalPages, start + 4);

    if (totalPages > 5 && end === totalPages) {
      start = Math.max(1, end - 4);
    }

    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  useEffect(() => {
    fetchCheck();
  }, [selectedService, selectedStatu, searchTerm, page, limit]); // Requête envoyée instantanément lorsque les filtres changent

  return (
    <div className="px-3 mt-36 sm:px-4 md:px-6 lg:px-8 py-4 bg-gray-100 dark:bg-gray-900 w-full flex flex-col rounded-xl">
      {/* Filtres et champ de recherche */}
      <div className="flex flex-wrap gap-2 mb-3">
        <select
          className="select select-bordered"
          value={selectedService}
          onChange={e => {
            setSelectedService(e.target.value);
            setPage(1);
          }}
        >
          <option value="">Tous les services</option>
          <option value="SNER">SNER</option>
          <option value="POLICE">POLICE</option>
          <option value="GENDARMERIE">GENDARMERIE</option>
        </select>
        <select
          className="select select-bordered"
          value={selectedStatu}
          onChange={e => {
            setSelectedStatu(e.target.value);
            setPage(1);
          }}
        >
          <option value="">Tous les statuts</option>
          <option value="0">Neutre</option>
          <option value="1">Recherché</option>
          <option value="3">Retrouvé</option>
        </select>
        
        {/* Sélecteur de nombre de lignes */}
        <div className="dropdown z-40">
          <div tabIndex={0} role="button" className="btn">
            {limit} lignes/page
          </div>
          <ul tabIndex={0} className="dropdown-content menu shadow bg-base-100 rounded-box w-40">
            {limitOptions.map(option => (
              <li key={option}>
                <button onClick={() => {
                  setLimit(option);
                  setPage(1);
                }}>
                  {option} lignes
                </button>
              </li>
            ))}
          </ul>
        </div>

        <input
          type="text"
          placeholder="Rechercher un Check..."
          className="input input-bordered w-full input-sm sm:input-md dark:bg-gray-700 dark:text-white"
          value={searchTerm}
          onChange={e => {
            setSearchTerm(e.target.value);
            setPage(1);
          }}
        />
      </div>

      {/* Barre de recherche avec compteur */}
      <div className="relative mb-4">
        <div className="absolute right-3 top-3">
          <span className="badge badge-ghost">
            {totalChecks} résultats
          </span>
        </div>
      </div>

      <div className="mt-4 overflow-x-auto overflow-y-auto h-[28rem] bg-base-100 rounded-xl shadow border border-base-200 mt-2">
        {loading ? (
          <div className="flex justify-center items-center h-32">
            <span className="loading loading-spinner loading-lg"></span>
          </div>
        ) : (
          <table className="table table-zebra w-full">
            <thead className="sticky top-0 z-10">
              <tr className="bg-base-200 text-xs sm:text-sm">
                <th className="whitespace-nowrap">FRANCHISE</th>
                <th className="whitespace-nowrap">CHÂSSIS</th>
                <th className="whitespace-nowrap">NOM</th>
                <th className="whitespace-nowrap">PRÉNOM</th>
                <th className="whitespace-nowrap">TÉLÉPHONE</th>
                <th className="whitespace-nowrap">CONTRÔLEUR</th>
                <th className="whitespace-nowrap">TÉL. CONTRÔLEUR</th>
                <th className="whitespace-nowrap">STATUT</th>
                <th className="whitespace-nowrap">DATE</th>
              </tr>
            </thead>
            <tbody>
            
  {Array.isArray(Check) && Check.length > 0 ? (
    Check.map((check) => (
                <tr key={check.id_Check} className="hover text-xs sm:text-sm">
                  <td>{check.franchise?.toUpperCase()}</td>
                  <td>{check.chassis?.toUpperCase()}</td>
                  <td>{check.nom?.toUpperCase()}</td>
                  <td>{check.prenom?.toUpperCase()}</td>
                  <td>{check.telephone || "N/A"}</td>
                  <td>{check.nom_controleur?.toUpperCase()}</td>
                  <td>{check.telephone_controleur || "N/A"}</td>
                  <td>
                    {check.statu === 1 ? (
                      <span className="badge badge-error font-bold text-white">RECHERCHÉ</span>
                    ) : (
                      <span className="">RAS</span>
                    )}
                  </td>
                  <td>{check.createdAt ? new Date(check.createdAt).toLocaleDateString() : "N/A"}</td>
                </tr>))
  ) : (
    <tr>
      <td colSpan="9" className="text-center">Aucun résultat</td>
    </tr>
  )}
   
            </tbody>
          </table>
        )}
      </div>

      {/* Pagination */}
      <div className="flex justify-center mt-4">
        <div className="join">
          <button
            className="join-item btn"
            disabled={page === 1}
            onClick={() => setPage(p => p - 1)}
          >
            «
          </button>

          {getPaginationNumbers().map(num => (
            <button
              key={num}
              className={`join-item btn ${page === num ? 'btn-active' : ''}`}
              onClick={() => setPage(num)}
            >
              {num}
            </button>
          ))}

          <button
            className="join-item btn"
            disabled={page === totalPages}
            onClick={() => setPage(p => p + 1)}
          >
            »
          </button>
        </div>
      </div>

      {/* MODALE DE CONFIRMATION */}

    </div>
  );
}
